// src/utils/avatarAssets.js
export const AVATAR_OPTIONS = [
  '/avatars/char1.jpg',
  '/avatars/char2.jpg',
  '/avatars/char3.jpg',
  '/avatars/char4.jpg',
  '/avatars/char5.jpg',
  '/avatars/char6.jpg',
  '/avatars/char7.jpg',
  '/avatars/char8.jpg',
  '/avatars/char9.jpg',
];